import { useGoogleLogin } from "@react-oauth/google";
import React from "react";
import toast from "react-hot-toast";
import { useAuth } from "../../context/AuthContext";
import api from "../../lib/api";
import { getErrorMessage } from "../../lib/errorUtils";

const GoogleLoginButton: React.FC = () => {
  const { setAuth } = useAuth();

  const onSuccess = (tokenResponse: any) => {
    const handleLogin = async () => {
      try {
        // Backend expects a "code" for access token exchange OR idToken path.
        // We'll use the code flow to call POST /v1/google-login-web
        const code = tokenResponse?.code as string;
        if (!code) {
          toast.error("Failed to login with Google. Please try again.");
          return;
        }

        const { data } = await api.post<{
          token: string;
          user: any;
        }>("/auth/google-login-web", {
          code,
          firstName: "",
          lastName: "",
        });

        setAuth({ token: data.token, user: data.user });
        toast.success("Successfully logged in!");
      } catch (e) {
        console.error("Google login error:", e);
        const errorMessage = getErrorMessage(e, "Failed to login with Google. Please try again.");
        toast.error(errorMessage);
      }
    };

    handleLogin();
  };

  const onError = () => {
    toast.error("Google login was cancelled or failed. Please try again.");
  };

  const login = useGoogleLogin({
    onSuccess,
    onError,
    flow: "auth-code",
    scope: "openid email profile",
  });

  return (
    <button
      onClick={() => login()}
      style={{
        padding: "0.5rem 1rem",
        borderRadius: 8,
        border: "1px solid #e1e5e9",
        background: "white",
        cursor: "pointer",
        fontWeight: 600,
      }}
    >
      Continue with Google
    </button>
  );
};

export default GoogleLoginButton;
